import { render, staticRenderFns } from "./ViewDocument.vue?vue&type=template&id=578fd582&scoped=true&"
import script from "./ViewDocument.vue?vue&type=script&lang=js&"
export * from "./ViewDocument.vue?vue&type=script&lang=js&"
import style0 from "./ViewDocument.vue?vue&type=style&index=0&id=578fd582&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578fd582",
  null
  
)

export default component.exports